//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
// import { log } from 'console';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------
//  -- List chapter interactions ------
export const handleListWhatsNew = () => async (dispatch) => {
    try {
        const whatsNew = await apis.get('whats_new', `/list`);
        if (Array.isArray(whatsNew)) {
            await dispatch(Actions.listWhatsNew(whatsNew));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing whats new',
                error,
                module: 'WHATS_NEW',
                operation: 'LIST_WELCOME_VIDEO'
            });
        }
        // console.log(error, "error in whatsNew");
    }
};
export const handleCreateWhatsNew = (data) => async (dispatch) => {
    try {
        const whatsNew = await apis.post('whats_new', `/create`, {
            body: data
        });
        if (has(data, "id")) {
            await dispatch(Actions.updateWhatsNew(whatsNew));
        } else {
            await dispatch(Actions.createWhatsNew(whatsNew));
        }
        return whatsNew;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating whats new',
                error,
                module: 'WHATS_NEW',
                operation: 'CREATE_WELCOME_VIDEO'
            });
        }
    }
};

export const handleDeleteWhatsNew = (id) => async (dispatch) => {
    try {
        const whatsNew = await apis.del('whats_new', `/delete/${id}`);
        if (has(whatsNew, "id")) {
            await dispatch(Actions.deleteWhatsNew(id));
        }
        return whatsNew;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting whats new',
                error,
                module: 'WHATS_NEW',
                operation: 'DELETE_WELCOME_VIDEO'
            });
        }
    }
};

export const handleCreateDontWhatsNew = (data) => async (dispatch) => {
    try {
        const whatsNew = await apis.post('whats_new', `/createUserSeen`, {
            body: data
        });
        // await dispatch(Actions.createWhatsNew(whatsNew));
        return whatsNew;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating dont whats new',
                error,
                module: 'WHATS_NEW',
                operation: 'CREATE_DEBATE_WORD_NOTE'
            });
        }
    }
};

//  -- List whats new popup ------
export const handleListPopupWhatsNew = (data) => async (dispatch) => {
    try {
        const whatsNew = await apis.post('whats_new', `/listPopup`, {
            body: data
        });
        if (Array.isArray(whatsNew)) {
            await dispatch(Actions.listWhatsNew(whatsNew));
        }
        return whatsNew;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing whats new popup',
                error,
                module: 'WHATS_NEW',
                operation: 'LIST_WELCOME_VIDEO_PREFERENCE'
            });
        }
    }
};
    